export default {"src":"/_next/static/media/Muscle Strains and Sprains.e36cdf84.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};